import React from 'react';
import { Trans } from '@lingui/macro';
import { Chip, makeStyles, Popover } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { SiteSummaryModel } from '@shared/models';
import { Button } from '@hwm/ui-lib';
import { ArrowDropUp } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  sites: {
    width: 36,
    display: ({ show }: { show: boolean }) => (show ? 'inherit' : 'none'),
  },
}));

interface AccountSitesIndicatorProps {
  accName?: string;
  selectedSites?: SiteSummaryModel[];
}

export const AccountSitesIndicator: React.FC<AccountSitesIndicatorProps> = ({ accName, selectedSites }) => {
  const classes = useStyles({ show: selectedSites && !isEmpty(selectedSites) });

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className="flex flex-row justify-start items-center" data-testid="account-sites-indicator">
      <div className="flex flex-col items-center mr-2">
        <p className="text-sm align-text-top" data-testid="account-sites-indicator-account-label">
          <Trans>Account</Trans>
        </p>
        <Chip
          data-testid="account-chip"
          label={accName ?? '-'}
          color="primary"
          style={{ maxWidth: 108, height: 28, color: 'white', fontWeight: 500 }}
        />
      </div>
      <div className={`flex flex-col justify-start items-center ${classes.sites}`}>
        <p className="text-sm align-text-top" data-testid="account-sites-indicator-sites-label">
          <Trans>Sites</Trans>
        </p>
        <Button
          className="flex flex-start"
          style={{
            height: 28,
            width: 44,
            minWidth: 44,
          }}
          onClick={handleClick}
          dataTestId="account-sites-indicator-sites-button"
        >
          {selectedSites?.length ?? null}
          <ArrowDropUp
            style={{
              marginRight: -4,
              transform: Boolean(anchorEl) ? '' : 'rotate(180deg)',
            }}
          />
        </Button>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className="flex flex-col px-3 pt-3 pb-2" data-testid="account-sites-indicator-sites-popover-content">
            {selectedSites.map((site, i) => (
              <Chip
                data-testid={`account-sites-indicator-sites-popover-content-site-${i}`}
                key={i}
                label={site?.siteID ?? '-'}
                color="primary"
                style={{
                  marginBottom: 4,
                  width: 200,
                  maxWidth: 200,
                  color: 'white',
                }}
              />
            ))}
          </div>
        </Popover>
      </div>
    </div>
  );
};
